import { StarChestHelper } from '../../Utility/StarChestHelper';
import Element, { IElementLayout } from '../../Prototype/UI/Element';
import GameObject from '../../GameObject/GameObject';
import Armature from '../../Prototype/Armature';
import UIImageComponent from '../../Component/UI/Image';
import Point from '../../Utility/Point';

export default class StarChest extends Element {
    public create(params: {
        name: string;
        layout: IElementLayout;
        tier: number;
        playIdleAnimation?: boolean;
    }) {
        const nextOrLastTier = StarChestHelper.getNextOrLastTier(params.tier);
        super.create({
            name: params.name,
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
                pivot: [0.5, 0.5],
                ...params.layout,
            },
            components: [],
            children: [
                {
                    name: 'star_chest_shiny',
                    layout: {
                        anchors: [0.5, 0.5, 0.5, 0.5],
                        offsets: [0, 0, 0, 0],
                        scale: [0.62, 0.62],
                        pivot: [0.5, 0.58],
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'map_chest_ani_effect_0',
                            },
                        },
                        {
                            type: 'transparency',
                            data: {
                                alpha: 0,
                            },
                        },
                    ],
                },
                {
                    name: 'star_chest_old',
                    layout: {
                        anchors: [0.5, 0.5, 0.5, 0.5],
                        offsets: [0, 0, 0, 0],
                        scale: [1, 1],
                        pivot: [0.5, 0.5],
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: StarChestHelper.getStarChestTexture(
                                    params.tier
                                ),
                                mipmap: true,
                            },
                        },
                        {
                            type: 'colorfilter',
                            data: {},
                        },
                    ],
                },
                {
                    name: 'star_chest_new',
                    layout: {
                        anchors: [0.5, 0.5, 0.5, 0.5],
                        offsets: [0, 0, 0, 0],
                        scale: [1, 1],
                        pivot: [0.5, 0.5],
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: StarChestHelper.getStarChestTexture(
                                    nextOrLastTier
                                ),
                            },
                        },
                        {
                            type: 'transparency',
                            data: {
                                alpha: 0,
                            },
                        },
                    ],
                },
            ],
        });
        if (params.playIdleAnimation) {
            const starChestOld = this.findChildByName('star_chest_old');
            const starChestNew = this.findChildByName('star_chest_new');
            const oldChestPosition = new Point(
                starChestOld.container.width / 2,
                starChestOld.container.height / 2
            );
            const newChestPosition = new Point(
                starChestNew.container.width / 2,
                starChestNew.container.height / 2
            );

            // Hide the chest texture behind the animated chests
            starChestOld.getComponent(UIImageComponent).texture = 'blank';
            starChestNew.getComponent(UIImageComponent).texture = 'blank';

            starChestOld.addChild(
                this.createIdleArmature(params.tier, oldChestPosition)
            );
            starChestNew.addChild(
                this.createIdleArmature(nextOrLastTier, newChestPosition)
            );
        }
    }
    private createIdleArmature(tier: number, offset: Point): Armature {
        const armature = GameObject.Instantiate<Armature>(Armature, {
            dragonbonesName: `chests_all`,
            armatureName: `chest_${tier}`,
            animationName: 'animation',
            x: offset.x,
            y: offset.y,
        });
        return armature;
    }
}
